























































import { Vue, Component } from 'vue-property-decorator'
import HeaderBar from '@/components/header-bar/index.vue'
import * as broadCastsService from '@/services/broadcast'
import { checkStatusMap } from '@/constants/statusMap'

interface CurType {
  id?: number
}

@Component({ components: { HeaderBar } })
export default class Playlists extends Vue {
  splaylist: Array<number> = []
  $toast: any

  checkStatusMap = checkStatusMap
  get playlists() {
    const arr: Array<object> = []
    //过滤播单，审核不通过的审核中的不显示
    const broadcasts = this.$store.state.broadcasts
    if (broadcasts && broadcasts.list) {
      const list = broadcasts.list
      for (let i = 0; i < list.length; i++) {
        if (
          list[i].checkState != 0 &&
          list[i].checkState != -1 &&
          list[i].checkState != 3
        ) {
          arr.push(list[i])
        }
      }
    }
    return arr
  }
  created() {
    if (this.$store.state.broadcasts.list.length == 0) {
      this.fetchPlaylists()
    }
  }
  fetchPlaylists() {
    return this.$store.dispatch('broadcasts/fetchUserPlaylist', {
      uuid: this.$store.state.userInfo.uuid,
      pageNo: 1,
      pageSize: 200,
      checkStatus: 6,
    })
  }
  onCheckPlaylist(event: Event, id: number) {
    if ((event.target as HTMLInputElement).checked) {
      this.splaylist.push(id)
    } else {
      const index = this.splaylist.indexOf(id)
      if (index > -1) {
        this.splaylist.splice(index, 1)
      }
    }
  }

  async addPlaylist() {
    const data: Array<object> = []
    //未选择播单
    if (this.splaylist.length == 0) {
      this.$toast('请选择播单')
      return
    }
    //组装添加播单数据
    this.splaylist.map(i => {
      data.push({
        videoId: this.$route.query.id,
        sortNo: 1,
        plId: i,
      })
    })
    const res = await broadCastsService.updatePlayVideos(data)
    if (res) {
      this.$toast(res.msg)
      if (res.code == 200) {
        this.$router.back()
      }
    }
  }
}
